module.exports = __webpack_public_path__ + "img/numberplateEuropeDe.3714ce55.svg";